/* Verduna Scroll-Reveal — beobachtet [data-vreveal]-Elemente und blendet sie
   beim Erscheinen im Viewport sanft ein. Container mit [data-vreveal-stagger]
   versehen ihre direkten Kinder automatisch mit gestaffelten Verzögerungen.
   Läuft im Head (ohne defer), damit der Versteck-Zustand vor dem ersten
   Paint gesetzt ist — kein Aufblitzen. */
(function () {
  'use strict';

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return; /* Editor: keine versteckten Elemente */

  document.documentElement.classList.add('vreveal-ready');

  /* Nach abgeschlossener Einblendung Attribut/Klasse wieder entfernen,
     damit eigene Hover-Transitions der Elemente ohne Verzögerung greifen. */
  function finish(el) {
    if (!el.hasAttribute('data-vreveal')) return;
    el.removeAttribute('data-vreveal');
    el.classList.remove('vreveal-in');
    el.style.removeProperty('--vr-delay');
  }

  function reveal(el) {
    el.classList.add('vreveal-in');
    el.addEventListener('transitionend', function onEnd(e) {
      if (e.target === el && e.propertyName === 'opacity') {
        el.removeEventListener('transitionend', onEnd);
        finish(el);
      }
    });
    setTimeout(function () { finish(el); }, 1600);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        reveal(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px 5% 0px', threshold: 0.05 });

  function scan(root) {
    var scope = (root && root.querySelectorAll) ? root : document;

    scope.querySelectorAll('[data-vreveal-stagger]').forEach(function (group) {
      if (group.hasAttribute('data-vreveal-prepared')) return;
      group.setAttribute('data-vreveal-prepared', '');
      /* Zentral zügiger: alle (auch pro Abschnitt fest gesetzten) Stagger-Werte
         um Faktor 0.55 stauchen, Deckel 320ms. */
      var step = Math.round((parseInt(group.getAttribute('data-vreveal-stagger'), 10) || 90) * 0.55);
      Array.prototype.forEach.call(group.children, function (child, i) {
        if (!child.hasAttribute('data-vreveal')) child.setAttribute('data-vreveal', '');
        child.style.setProperty('--vr-delay', Math.min(i * step, 320) + 'ms');
      });
    });

    scope.querySelectorAll('[data-vreveal]:not(.vreveal-in)').forEach(function (el) {
      var delay = el.getAttribute('data-vreveal-delay');
      if (delay) el.style.setProperty('--vr-delay', Math.round(delay * 0.55) + 'ms');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  window.vReveal = { scan: scan };
})();
